module.exports = __webpack_public_path__ + "static/media/12UNCTAD12.a3d45f52.jpg";